/**
 * Created by r4zi4l on 28.07.2022
 */

const Snapshots = function () {
    const delta = cleverapps.dataLoader.load(DataLoader.TYPES.SNAPSHOT_TIME_DELTA);
    DateShift.setShift(delta);

    if (delta) {
        const userData = cleverapps.user.getInfo();
        userData.forcedVisited = userData.visited + delta;
        delete userData.visited;
        cleverapps.user.updateInfo(userData);
    }

    if (cleverapps.isLocalhost()) {
        this.dbStore = new IndexedDBStore("snapshots");
    }
};

Snapshots.prototype.reset = function () {
    DateShift.setShift(0);
    cleverapps.dataLoader.remove(DataLoader.TYPES.SNAPSHOT_TIME_DELTA);
};

Snapshots.prototype._migrateSnapshot = function (snapshot) {
    // migration from local checkpoints
    if (snapshot.data) {
        Object.keys(snapshot.data).forEach((key) => {
            const tokens = key.split("_");

            if (tokens[0] !== "units") {
                return;
            }

            const code = tokens[1];
            const slotId = tokens[2] || "";

            if (!snapshot.data[`units${slotId}`]) {
                snapshot.data[`units${slotId}`] = {};
            }

            snapshot.data[`units${slotId}`][code] = snapshot.data[key];
            delete snapshot.data[key];
        });

        snapshot = snapshot.data;
    }

    // migration from old snapshots
    if (snapshot.sync) {
        snapshot.sync.date = snapshot.date;
        snapshot.sync.settings = snapshot.settings;
        snapshot = snapshot.sync;
    }

    if (snapshot.scene && snapshot.scene.episodeNo === "undersea2") {
        snapshot.scene.episodeNo = "undersea";
        snapshot.scene.levelNo = 1;
    }

    // migrate from levels to locations
    if (snapshot.scene && snapshot.scene.levelNo && cleverapps.config.type === "merge") {
        snapshot.scene.episodeNo += snapshot.scene.levelNo + 1;
        snapshot.scene.levelNo = 0;
    }

    if (snapshot.scene && (snapshot.scene.episodeNo === 0 || snapshot.scene.episodeNo === "0") && cleverapps.config.type === "merge") {
        snapshot.scene.episodeNo = "main";
    }

    if (snapshot.scene && snapshot.scene.location === undefined) {
        snapshot.scene.location = snapshot.scene.episodeNo;
    }

    if (snapshot.scene && snapshot.scene.location > 0 && cleverapps.config.name === "garden") {
        snapshot.scene.location = 0;
        snapshot.scene.episodeNo = 0;
    }

    // migrate to units library with slots
    if (snapshot.unitslibrary && !snapshot.unitslibrary1) {
        snapshot.unitslibrary1 = snapshot.unitslibrary1 || {};
        snapshot.unitslibrary2 = snapshot.unitslibrary2 || {};
        snapshot.unitslibrary3 = snapshot.unitslibrary3 || {};
        snapshot.unitslibrary4 = snapshot.unitslibrary4 || {};
        snapshot.unitslibrary5 = snapshot.unitslibrary5 || {};
    }

    if (snapshot.metha && snapshot.metha.locations && snapshot.metha.locations.spring26) {
        snapshot.metha.locations.spring26.slot = "5";
    }

    return snapshot;
};

Snapshots.prototype.importData = function (snapshot, callback) {
    cleverapps.meta.stopLocation();

    if (!snapshot.abtest) {
        snapshot.abtest = {};
    }

    if (!snapshot.metha) {
        snapshot.metha = {};
    }

    if (!snapshot.playSession) {
        snapshot.playSession = {};
    }

    if (!snapshot.weeklygoals) {
        snapshot.weeklygoals = {};
    }

    if (snapshot.metha && snapshot.metha.locations) {
        const availableLocations = typeof Meta !== "undefined" && Meta.GetAvailableLocations && Meta.GetAvailableLocations() || {};
        Object.keys(snapshot.metha.locations).forEach((id) => {
            const location = availableLocations[id];
            if (location && location.retire && new Date(location.retire).getTime() <= Date.now()) {
                delete snapshot.metha.locations[id];

                if (snapshot.scene && snapshot.scene.location === id) {
                    snapshot.scene.location = "main";
                }
                if (snapshot.scene && snapshot.scene.episodeNo === id) {
                    snapshot.scene.episodeNo = "main";
                }
            }
        });

        Object.values(snapshot.metha.locations).forEach((data) => {
            if (data.v) {
                data.version = data.v;
                delete data.v;
            }
            if (data.st) {
                data.started = data.st;
                delete data.st;
            }
            if (data.sl) {
                data.slot = data.sl;
                delete data.sl;
            }
        });
    }

    cleverapps.snapshots.reset();

    cleverapps.user.sendLetsPlayPush();
    connector.notifications.cancelAll();

    if (cleverapps.unitsSyncers) {
        cleverapps.unitsSyncers.reset();
    }

    cleverapps.dataSlots.reset();

    if (typeof UnitsLibraryHelper !== "undefined") {
        UnitsLibraryHelper.Reset();
    }

    snapshot.achievements = snapshot.achievements || "";
    snapshot.energyProducts = snapshot.energyProducts || {};
    snapshot.adsLimits = snapshot.adsLimits || {};

    if (snapshot.date) {
        const delta = snapshot.date - Date.now();
        DateShift.setShift(delta);
        cleverapps.dataLoader.save(DataLoader.TYPES.SNAPSHOT_TIME_DELTA, delta);
    }

    if (!snapshot.abtest) {
        cleverapps.dataLoader.remove(DataLoader.TYPES.ABTEST);
    }

    cleverapps.timeStart = Date.now();

    let type;
    const adapters = {};

    for (type in SnapshotAdapters) {
        adapters[type] = SnapshotAdapters[type];
    }

    for (type in SyncAdapters) {
        if (!adapters[type]) {
            adapters[type] = SyncAdapters[type];
        }
    }

    const syncTypes = Object.keys(adapters);
    syncTypes.sort((a, b) => (adapters[a].order || 0) - (adapters[b].order || 0));

    if (!cleverapps.config.importMode) {
        snapshot.users.id = undefined;
    } else if (snapshot.users.id) {
        connector.platform.setUserID(snapshot.users.id);

        if (connector.social.oneOf(connector.TEST) && snapshot.isLoggedIn) {
            connector.social.getPlugin().updateSession(snapshot.users.id);
        }
    }

    for (const type of syncTypes) {
        if (adapters[type].beforeUpdate) {
            adapters[type].beforeUpdate(snapshot);
        }
    }

    for (const type of syncTypes) {
        if (type in snapshot) {
            const adapter = adapters[type];
            if (adapter.updateInfo) {
                const data = cleverapps.clone(snapshot[type], true);
                adapter.updateInfo(data);
            }
        }
    }

    for (const type of syncTypes) {
        if (adapters[type].afterUpdate) {
            adapters[type].afterUpdate();
        }
    }

    if (cleverapps.travelBook) {
        cleverapps.travelBook.init();
    }

    Messages.loadLanguage(cleverapps.settings.language, callback);
};

Snapshots.prototype.importSnapshot = function (snapshot) {
    snapshot = this._migrateSnapshot(snapshot);

    snapshot = cleverapps.clone(snapshot, true);
    cleverapps.tutorial.stop();
    const actions = [
        (f) => {
            new ConflictWindow({
                localSnapshot: connector.synchronizer.getLocalSnapshot(),
                remoteSnapshot: snapshot,
                callback: f
            });
        },

        (f) => {
            cleverapps.tutorial.stop();
            connector.synchronizer.setStatus(connector.SYNC_STATUS.IDLE);

            cleverapps.snapshots.importData(snapshot, f);
        },

        (f) => {
            if (snapshot.scene) {
                cleverapps.reloadSnapshotScene(snapshot.scene, f);
            } else {
                cleverapps.Scenes.SceneRefresh();
            }

            connector.synchronizer.syncOut();
        }
    ];

    if (cleverapps.focusManager.isFocused()) {
        cleverapps.focusManager.distract({
            focus: "override",
            actions
        });
    } else {
        cleverapps.focusManager.display({
            focus: "override",
            actions
        });
    }
};

Snapshots.prototype.canCreate = function () {
    const environment = cleverapps.environment;
    if (environment.isEditorScene() || environment.isAdministratorScene()
        || environment.isAtlasAnalyzerScene()) {
        cleverapps.notification.create("Can't take snapshot on current scene");
        return false;
    }

    if (typeof Game !== "undefined" && Game.currentGame && Game.currentGame.outcome === GameBase.OUTCOME_VICTORY) {
        cleverapps.notification.create("Can't take snapshot if outcome is victory");
        return false;
    }

    return true;
};

Snapshots.prototype.createSnapshot = function (data, onSuccess) {
    if (!this.canCreate()) {
        return;
    }

    onSuccess = onSuccess || function (targetUrl) {
        cleverapps.copyToClipboard(targetUrl, () => {
            cleverapps.notification.create("snapshot copied to clipboard");
        });
        this.openInNewTab(targetUrl);
    }.bind(this);

    const create = function (data) {
        const id = Math.random().toString(36).slice(2);

        this.saveSnapshot(id, data, onSuccess);
    }.bind(this);

    if (typeof Game !== "undefined" && Game.currentGame && Game.currentGame.introPlaying && Game.currentGame.cachedIntro) {
        create(Game.currentGame.cachedIntro);
        return;
    }

    if (data) {
        create(data);
    } else {
        SnapshotAdapters.extractData(create);
    }
};

Snapshots.prototype.saveSnapshot = function (id, data, onSuccess) {
    if (cleverapps.isLocalhost()) {
        this.dbStore.set(id, data, () => {
            onSuccess(`#snapshot=${id}`);
        });
    } else {
        this.uploadSnapshot(id, data, onSuccess);
    }
};

Snapshots.prototype.uploadSnapshot = function (id, data, onSuccess) {
    const restUrl = cleverapps.RestClient.standsRest(`/snapshots/create/${id}`);
    const jsonUrl = cleverapps.RestClient.standsRest(`/snapshots/get/${id}.json`).replace("https://", "");
    const targetUrl = `${cleverapps.RestClient.standsWeb("/")}?snapshot=${jsonUrl}`;

    cleverapps.RestClient.post(restUrl, data, () => {
        onSuccess(targetUrl);
    }, (error) => {
        console.log("connection error", error);
        cleverapps.notification.create(error.errorMessage || error.statusText || error);
    }, {
        ignoreNoRest: true
    });
};

Snapshots.prototype.openInNewTab = function (url) {
    connector.platform.openUrl(url);
};

Snapshots.prototype.getUrlById = function (id) {
    return cleverapps.RestClient.standsRest(`/snapshots/get/${id}.json`);
};

Snapshots.prototype.getSnapshot = function (id, callback) {
    if (cleverapps.isLocalhost()) {
        this.dbStore.get(id, (snapshot) => {
            if (snapshot) {
                // console.warn(snapshot);
                callback(snapshot);
            } else {
                this.getSnapshotFromUrl(this.getUrlById(id), (snapshot) => {
                    if (snapshot) {
                        // console.warn(snapshot);
                        this.saveSnapshot(id, snapshot, () => {});
                    }

                    callback(snapshot);
                });
            }
        });
    } else {
        this.getSnapshotFromUrl(this.getUrlById(id), callback);
    }
};

Snapshots.prototype.getSnapshotFromUrl = function (url, callback) {
    cc.loader.load(
        url,
        (error, response) => {
            if (error || !response || !response[0]) {
                console.error("Failed to load snapshot", url, error, response);
                cleverapps.notification.create("Failed to load snapshot");
                return;
            }
            callback(response[0]);
        }
    );
};

Snapshots.prototype.exportToJson = function (snapshot) {
    const element = document.createElement("a");
    element.href = URL.createObjectURL(new Blob([JSON.stringify(snapshot, null, 4)], {
        type: "application/json"
    }));
    element.setAttribute("download", `${cleverapps.config.name}_${cleverapps.user.getHumanReadableNumber()}.json`);
    element.style.display = "none";

    document.body.appendChild(element);

    element.click();

    document.body.removeChild(element);
};

Snapshots.prototype.downloadToLocalhost = function (snapshotId) {
    this.openInNewTab(`http://localhost/${cleverapps.config.name}/#snapshot=${snapshotId}`);
};

Snapshots.prototype.uploadToStaging = function (snapshot) {
    this.uploadSnapshot(snapshot.snapshotId, snapshot, (targetUrl) => {
        this.openInNewTab(targetUrl);
    });
};

Snapshots.prototype.importFromUrl = function (callback) {
    const url = prompt("enter snapshot url");

    let id = url && url.replace(/.*snapshot=([^&#]+).*/, "$1");
    if (id === url) {
        id = url && url.replace(/^https?:\/\/[^/]+\/([A-Za-z0-9]+)$/, "$1");
    }
    if (!id) {
        return;
    }

    if (id.indexOf("/") !== -1) {
        this.getSnapshotFromUrl(/^https?:\/\//.test(id) ? id : `https://${id}`, callback);
        return;
    }

    this.getSnapshot(id, (snapshot) => {
        callback(snapshot);
    });
};
